var _path, _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F97A(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcea2b",
    d: "M35.94 12.58l-8.9 1.73-5.46 3.12-5.04 5.23L13 30.24v12.72l5.77 9.69 8.27 5.62 8.9 1.73 7.4-1.19 7.94-4.46L56.55 48l3.09-9.49-.77-8.23-3.93-8.15-4.34-4.46-7.47-3.97z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.45,
    cy: 31.38,
    r: 6.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.76,
    cy: 31.38,
    r: 6.5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 23,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M29.02 46.68c1.379-1.678 4.279-2.713 7.347-2.628 2.817.079 5.358 1.091 6.612 2.628"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.56,
    cy: 31.38,
    r: 6.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.65,
    cy: 31.38,
    r: 6.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M27.53 25.77a4.619 4.619 0 00-4.592 4.619 4.619 4.619 0 004.619 4.619 4.619 4.619 0 004.619-4.619 4.619 4.619 0 00-4.619-4.619 4.619 4.619 0 00-.027 0zm-1.453 1.828a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 012-2zM44.62 25.77a4.619 4.619 0 00-4.592 4.619 4.619 4.619 0 004.619 4.619 4.619 4.619 0 004.619-4.619 4.619 4.619 0 00-4.619-4.619 4.619 4.619 0 00-.027 0zm-1.453 1.828a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 012-2z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M41.31 18.02c1.185 2.421 3 5 9 4M30.96 18.02c-1.185 2.421-3 5-9 4"
  }))));
}
export default Svg1F97A;